import React, { useContext } from 'react';
import { Section } from 'src/components/Section';
import UserInvoiceDetails from 'src/components/UserDetails/InvoiceDetails/UserInvoiceDetails';
import { AppContext } from 'src/contexts/AppContext';
import { BookingContext } from 'src/contexts/BookingFlowContext';
import { ReservationEndContext } from 'src/contexts/ReservationEndContext';
import { IValidation } from 'src/services/formValidator';
import globalMessages from 'src/services/globalMessages';

export interface IUserInvoiceDetailsSectionProps {
    validation: IValidation;
}

const UserInvoiceDetailsSection: React.FC<IUserInvoiceDetailsSectionProps> = ({ validation }) => {

    const { company } = useContext(AppContext);
    const { reservationEndUser, actions: { handleInvoiceChange } } = useContext(BookingContext);
    const { selectedPayment, displayedSubtotal } = useContext(ReservationEndContext);

    return (
        (company?.PaymentSettings.IsBillingEnabled &&
            selectedPayment?.NeedsInvoice && reservationEndUser &&
            displayedSubtotal && displayedSubtotal?.Price !== 0)
            ?
            <Section title={globalMessages.invoiceDetails}>
                <UserInvoiceDetails
                    defaultUserInvoice={reservationEndUser.InvoiceDetails}
                    handleInvoiceChange={handleInvoiceChange}
                    validation={validation} />
            </Section>
            :
            null
    )
}

export default UserInvoiceDetailsSection;